var map = {
	"./amex.png": 2451,
	"./bancontact.png": 2452,
	"./mastercard.png": 2453,
	"./visa.png": 2454
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2467;



//////////////////
// WEBPACK FOOTER
// ./shared/components/PaymentOption/assets ^\.\/.*\.png$
// module id = 2467
// module chunks = 0